import React from 'react'
import parse from 'html-react-parser'

const Content = ({ content, className }) => (
  <div className={className}>{parse(content)}</div>
)

export default Content
